import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { imgUrl } from "@/lib/api";

export function Lightbox({ images, index, onClose, onNavigate }) {
  const open = index !== null && index >= 0;
  const current = open ? images[index] : null;
  return (
    <AnimatePresence>
      {open && current && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={onClose}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white/80 hover:text-white p-2 rounded-full bg-white/10"
            data-testid="lightbox-close-btn"
            aria-label="Close"
          >
            <X className="h-6 w-6" />
          </button>
          {images.length > 1 && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onNavigate((index - 1 + images.length) % images.length);
                }}
                className="absolute left-3 text-white/80 hover:text-white p-2 rounded-full bg-white/10"
                data-testid="lightbox-prev-btn"
                aria-label="Previous"
              >
                <ChevronLeft className="h-6 w-6" />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onNavigate((index + 1) % images.length);
                }}
                className="absolute right-3 text-white/80 hover:text-white p-2 rounded-full bg-white/10"
                data-testid="lightbox-next-btn"
                aria-label="Next"
              >
                <ChevronRight className="h-6 w-6" />
              </button>
            </>
          )}
          <motion.figure
            key={current.id || index}
            initial={{ scale: 0.92, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.25 }}
            className="max-w-4xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={imgUrl(current.url)} alt={current.caption || "Gallery image"} className="w-full max-h-[78vh] object-contain rounded-lg" />
            {current.caption && <figcaption className="text-center text-white/80 mt-4 text-sm">{current.caption}</figcaption>}
          </motion.figure>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
